import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import useFetch from "../../utils/useFetch";
import ActivePulseBullet, { DeactivePulseBullet } from "../activePulseBullet";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useWindowSize from "../../utils/useWindowSize";
import desktopSliderImage from "../../assets/images/slider_desktop.jpg";

const PageHeader = () => {
  const appSettings = useSelector((store: RootState) => store.app.appSettings);
  const isOutOfServiceTime = useSelector(
    (store: RootState) => store.app.isOutOfServiceTime
  );

  const isAppOutOfService = useSelector(
    (store: RootState) => store.app.isAppOutOfService
  );

  const { data: slides } = useFetch<any[]>("headerslides");

  const settings = {
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
  };
  const { width } = useWindowSize();

  return (
    <>
      {width > 768 && (
        <div>
          <img
            src={desktopSliderImage}
            alt='desktopSliderImage'
            style={{ display: "inline-block", width: "100%" }}
          />
        </div>
      )}
      {width <= 768 && (
        <div style={{ height: "100vw" }}>
          <Slider {...settings}>
            {slides &&
              slides?.map((slide) => (
                <div style={{ height: "50vw" }}>
                  <div style={{ height: "100vw" }}>
                    {slide.type === "video" && (
                      <video
                        autoPlay={true}
                        loop
                        playsInline
                        muted
                        src={"http://app.tiarafood.ir/slide/" + slide.name}
                      />
                    )}
                    {slide.type === "picture" && (
                      <img
                        className=' w-full h-full'
                        alt={slide.id}
                        src={"http://app.tiarafood.ir/slide/" + slide.name}
                      />
                    )}
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      )}

      <header className='p-4 text-center  text-white bg-auto bg-center bg-gray-700'>
        {/* <div className='text-4xl font-bold'>رستوران بین المللی تیارا</div> */}

        {!isAppOutOfService && isOutOfServiceTime && (
          <>
            <div>
              <DeactivePulseBullet /> سفارش نمی پذیریم
            </div>
            <div className='mt-2'>
              سفارش گیری از {appSettings.shifts.shift_one.start} الی{" "}
              {appSettings.shifts.shift_one.end} و{" "}
              {appSettings.shifts.shift_two.start} الی{" "}
              {appSettings.shifts.shift_two.end}
            </div>
          </>
        )}

        {!isAppOutOfService && !isOutOfServiceTime && (
          <>
            <div>
              <ActivePulseBullet />
              سفارش می پذیریم
            </div>
          </>
        )}

        {isAppOutOfService && (
          <>
            <div>
              <DeactivePulseBullet /> سفارش نمی پذیریم
            </div>
          </>
        )}
      </header>
    </>
  );
};

export default PageHeader;
